/*
 * scoped-search.js  —  single source of truth for storefront search behavior.
 *
 * Rewrites every <form data-title-search> submission so results match the product
 * TITLE, TAGS, PRODUCT TYPE, or SKU (not description/vendor), and auto-corrects
 * common misspellings. Also strips apostrophes so "men's" matches the "mens" tag.
 * SKU-like words ("26764", "NX-26764") are searched unscoped so partial SKUs match.
 *
 * Covers the header search forms AND the search-results-page form. Loaded as its
 * own file (not inside the header menu script) so it always registers, and so the
 * misspelling list below is the ONLY place to maintain.
 */
(function () {
const FIELDS = ['title', 'tag', 'product_type', 'variants.sku'];

  /* Common-misspelling map. Native search has no typo tolerance, so we fix
     known typos here before searching. Keys/values must be lowercase single
     words. Add your store's frequent misspellings to this list. */
  const SEARCH_CORRECTIONS = {
    // --- Gemstones ---
    tuquoise: 'turquoise', turquiose: 'turquoise', turqoise: 'turquoise', turquose: 'turquoise', turquois: 'turquoise', turquoize: 'turquoise', tourquoise: 'turquoise', torquoise: 'turquoise', turqouise: 'turquoise', turquoisse: 'turquoise',
    saphire: 'sapphire', saphhire: 'sapphire', sapphira: 'sapphire', sapire: 'sapphire', safire: 'sapphire', saphir: 'sapphire', sapphir: 'sapphire', sapfire: 'sapphire', saphfire: 'sapphire', sappire: 'sapphire', saffire: 'sapphire',
    emrald: 'emerald', emerld: 'emerald', emarald: 'emerald', emrold: 'emerald', emeraled: 'emerald', emmerald: 'emerald', emralld: 'emerald', emeral: 'emerald', emerlad: 'emerald',
    amethist: 'amethyst', ametyst: 'amethyst', amythist: 'amethyst', amethyist: 'amethyst', amathyst: 'amethyst', amethsyt: 'amethyst', amethyest: 'amethyst', ametist: 'amethyst',
    dimond: 'diamond', diamand: 'diamond', daimond: 'diamond', diamnd: 'diamond', diamon: 'diamond', dimaond: 'diamond', diamound: 'diamond', diomond: 'diamond', dianmond: 'diamond', diamomd: 'diamond',
    rubby: 'ruby', rubi: 'ruby', rubie: 'ruby', rubey: 'ruby',
    topas: 'topaz', topaze: 'topaz', topazz: 'topaz', topajz: 'topaz', toppaz: 'topaz',
    opel: 'opal', oppal: 'opal', opale: 'opal',
    perl: 'pearl', pearel: 'pearl', pearll: 'pearl', pearal: 'pearl', peral: 'pearl', pearrl: 'pearl',
    garnett: 'garnet', garnat: 'garnet', garnit: 'garnet', garenet: 'garnet', granet: 'garnet', garnut: 'garnet',
    aquamarne: 'aquamarine', aquamrine: 'aquamarine', acquamarine: 'aquamarine', aquamarin: 'aquamarine', aquamareen: 'aquamarine', aquamerine: 'aquamarine', aqumarine: 'aquamarine', aquamarene: 'aquamarine',
    citrene: 'citrine', citrin: 'citrine', citreen: 'citrine', sitrine: 'citrine', citrinne: 'citrine', cintrine: 'citrine',
    peridott: 'peridot', peridote: 'peridot', perridot: 'peridot', peridit: 'peridot', peidot: 'peridot', peirdot: 'peridot',
    tanzanit: 'tanzanite', tanzenite: 'tanzanite', tanznite: 'tanzanite', tanzinite: 'tanzanite', tanzanight: 'tanzanite', tanzaniet: 'tanzanite',
    tourmalin: 'tourmaline', turmaline: 'tourmaline', tourmeline: 'tourmaline', tormaline: 'tourmaline', tourmalline: 'tourmaline', tourmoline: 'tourmaline', tourmalene: 'tourmaline',
    moonstne: 'moonstone', monstone: 'moonstone', moostone: 'moonstone', moonston: 'moonstone', moonstome: 'moonstone',
    onix: 'onyx', onyxe: 'onyx', onnyx: 'onyx',
    jaid: 'jade', jayd: 'jade', jadee: 'jade',
    corral: 'coral', corel: 'coral', corall: 'coral',
    ambar: 'amber', ambre: 'amber', ambber: 'amber',
    lapiz: 'lapis', lappis: 'lapis', lapus: 'lapis',
    lazouli: 'lazuli', lazulli: 'lazuli', lazuly: 'lazuli',
    quarts: 'quartz', qwartz: 'quartz', quartze: 'quartz', kwartz: 'quartz', quarz: 'quartz', quatz: 'quartz',
    zicon: 'zircon', zircron: 'zircon', zirkon: 'zircon', zircone: 'zircon',
    zirconi: 'zirconia', zerconia: 'zirconia', zirconnia: 'zirconia',
    alexandrit: 'alexandrite', alexndrite: 'alexandrite', alexanrite: 'alexandrite', alexandright: 'alexandrite', alexanderite: 'alexandrite',
    morganit: 'morganite', morgenite: 'morganite', morganight: 'morganite', morgonite: 'morganite', morganiet: 'morganite',
    spinell: 'spinel', spinnel: 'spinel', spenel: 'spinel', spinelle: 'spinel',
    iolight: 'iolite', iolit: 'iolite',
    kunzit: 'kunzite', kuznite: 'kunzite', kunzight: 'kunzite',
    chalcedny: 'chalcedony', chalcedoney: 'chalcedony', calcedony: 'chalcedony',
    cornelian: 'carnelian', carnalian: 'carnelian', carnelion: 'carnelian', carnellian: 'carnelian',
    malicite: 'malachite', malachit: 'malachite', malakite: 'malachite', malacite: 'malachite',
    rhinestne: 'rhinestone', rinestone: 'rhinestone', rhienstone: 'rhinestone', rhinstone: 'rhinestone',
    moisanite: 'moissanite', moissonite: 'moissanite', moissenite: 'moissanite', mossanite: 'moissanite',

    // --- Extra coverage for the 15 stones we carry ---
    amethyt: 'amethyst', amethst: 'amethyst', amythst: 'amethyst', amthyst: 'amethyst', amethsit: 'amethyst', amytheyst: 'amethyst',
    aquamaine: 'aquamarine', aquamrin: 'aquamarine', aqamarine: 'aquamarine', aquamearine: 'aquamarine', aquamariene: 'aquamarine', aquimarine: 'aquamarine',
    citirine: 'citrine', citrien: 'citrine', citrne: 'citrine', citreene: 'citrine', citryne: 'citrine', cittrine: 'citrine',
    diamonnd: 'diamond', dimand: 'diamond', diamnod: 'diamond', diaomnd: 'diamond', diammond: 'diamond', dyamond: 'diamond', diamd: 'diamond',
    emerad: 'emerald', emeryld: 'emerald', emmarald: 'emerald', emorald: 'emerald', emurald: 'emerald', emrauld: 'emerald', emeralld: 'emerald',
    garent: 'garnet', garnete: 'garnet', garnnet: 'garnet', garrnet: 'garnet', gernet: 'garnet', garrnett: 'garnet',
    jaide: 'jade', jadde: 'jade', jaed: 'jade', jayde: 'jade',
    onx: 'onyx', oniks: 'onyx', onexe: 'onyx', onnix: 'onyx', onicks: 'onyx', onxy: 'onyx',
    pearle: 'pearl', prl: 'pearl', perle: 'pearl', peorl: 'pearl', pearrel: 'pearl',
    quartx: 'quartz', qartz: 'quartz', quardz: 'quartz', quartzz: 'quartz', cuartz: 'quartz', quartss: 'quartz',
    ruvy: 'ruby', rubbie: 'ruby', rubyy: 'ruby', ruey: 'ruby',
    sapphier: 'sapphire', saphyre: 'sapphire', sapphfire: 'sapphire', saphiire: 'sapphire', sapphre: 'sapphire', saphhira: 'sapphire',
    tansanite: 'tanzanite', tanzaite: 'tanzanite', tanzannite: 'tanzanite', tanzenight: 'tanzanite', tanznight: 'tanzanite',
    turquiese: 'turquoise', terquoise: 'turquoise', turchoise: 'turquoise', turqouis: 'turquoise', turquoisee: 'turquoise', turkquoise: 'turquoise',
    tourmalne: 'tourmaline', turmalin: 'tourmaline', tourmiline: 'tourmaline', tourmalime: 'tourmaline', tormalin: 'tourmaline',

    // --- Jewelry types ---
    neclace: 'necklace', necklance: 'necklace', necklise: 'necklace', neckless: 'necklace', necklac: 'necklace', necklaice: 'necklace', necklase: 'necklace', neckalace: 'necklace',
    braclet: 'bracelet', bracelett: 'bracelet', braclette: 'bracelet', braselet: 'bracelet', brecelet: 'bracelet', braclete: 'bracelet', brasslet: 'bracelet',
    earings: 'earrings', earing: 'earrings', earrigs: 'earrings', earrring: 'earrings', earrigns: 'earrings', earinngs: 'earrings', erring: 'earrings',
    pendent: 'pendant', pendnat: 'pendant', pendat: 'pendant', pendand: 'pendant', pandant: 'pendant', penndant: 'pendant',
    broach: 'brooch', brooche: 'brooch', broch: 'brooch', brouche: 'brooch', broooch: 'brooch',
    ancklet: 'anklet', anklett: 'anklet', anclet: 'anklet', anklit: 'anklet',
    cuflinks: 'cufflinks', cufflink: 'cufflinks', cuflink: 'cufflinks', cufflinnks: 'cufflinks',
    lockett: 'locket', loket: 'locket', lockit: 'locket', lockat: 'locket',
    choaker: 'choker', chocker: 'choker', chokker: 'choker',
    tierra: 'tiara', tiarra: 'tiara', taira: 'tiara',
    bangel: 'bangle', bangl: 'bangle', banggle: 'bangle',
    signit: 'signet', signett: 'signet', signat: 'signet',
    rign: 'ring', rng: 'ring',
    chian: 'chain', chaine: 'chain', chainn: 'chain',
    charmm: 'charm',

    // --- Metals ---
    golde: 'gold', glod: 'gold', goldd: 'gold',
    sliver: 'silver', silber: 'silver', silvar: 'silver', sivler: 'silver', silverr: 'silver', siver: 'silver',
    platinium: 'platinum', platnum: 'platinum', platinm: 'platinum', plantinum: 'platinum', platium: 'platinum', platnium: 'platinum', platinun: 'platinum',
    vermil: 'vermeil', vermeille: 'vermeil', vermeal: 'vermeil', vermiel: 'vermeil', vemeil: 'vermeil',
    sterlling: 'sterling', sterlng: 'sterling', sterlin: 'sterling', sterliing: 'sterling',

    // --- Eras & styles ---
    vintge: 'vintage', vintag: 'vintage', vintiage: 'vintage', vinatge: 'vintage', vitnage: 'vintage', vintague: 'vintage',
    antiqe: 'antique', antiue: 'antique', anitque: 'antique', antik: 'antique', antigue: 'antique', antqiue: 'antique', atique: 'antique', antuque: 'antique',
    estat: 'estate', esate: 'estate', estste: 'estate',
    edwardain: 'edwardian', edwardean: 'edwardian', edwardion: 'edwardian',
    victorain: 'victorian', victorien: 'victorian', victoran: 'victorian', victorion: 'victorian',
    georgain: 'georgian', georgion: 'georgian', gorgian: 'georgian',
    nouvo: 'nouveau', nouveu: 'nouveau', nuveau: 'nouveau', noveau: 'nouveau', nouveaux: 'nouveau',
    filagree: 'filigree', filligree: 'filigree', filigre: 'filigree', filigee: 'filigree', philligree: 'filigree',
    cammeo: 'cameo', camio: 'cameo', cameoo: 'cameo', cameeo: 'cameo',
    enemel: 'enamel', enammel: 'enamel', enamal: 'enamel', enanel: 'enamel',

    // --- Cuts & settings ---
    solitair: 'solitaire', solataire: 'solitaire', solitare: 'solitaire', soltaire: 'solitaire', solitiare: 'solitaire', solotaire: 'solitaire',
    marquis: 'marquise', marquisse: 'marquise', marquize: 'marquise', marqise: 'marquise', markquise: 'marquise',
    cushon: 'cushion', cusion: 'cushion', cushin: 'cushion', cusshion: 'cushion',
    princes: 'princess', princesse: 'princess', princeess: 'princess',
    baugette: 'baguette', baget: 'baguette', baguet: 'baguette', bagette: 'baguette', baguettte: 'baguette',
    brillient: 'brilliant', briliant: 'brilliant', brillant: 'brilliant', brilliannt: 'brilliant',
    caboshon: 'cabochon', cabachon: 'cabochon', cabuchon: 'cabochon', cobochon: 'cabochon', cabochan: 'cabochon',
    bezle: 'bezel', bezzel: 'bezel', bezal: 'bezel', bezil: 'bezel',
    eturnity: 'eternity', eternety: 'eternity', eterntiy: 'eternity',

    // --- Other ---
    jewellry: 'jewelry', jewlery: 'jewelry', jewelery: 'jewelry', jewelary: 'jewelry', jewlry: 'jewelry', jewellery: 'jewelry', joolery: 'jewelry', jewerly: 'jewelry', jewlrey: 'jewelry',
    gemstne: 'gemstone', gemston: 'gemstone', jemstone: 'gemstone',
    birthstne: 'birthstone', birthston: 'birthstone', brithstone: 'birthstone',
    carrot: 'carat', carrat: 'carat', karrat: 'carat',
  };

  var toScopedQuery = function (raw) {
    var tokens = raw
      .trim()
      .split(/\s+/)
      // strip apostrophes (straight + curly) and query-grammar chars, lowercase for lookup
      .map(function (t) { return t.replace(/['\u2018\u2019\u02bc"*:()]/g, '').toLowerCase(); })
      .filter(Boolean)
      .map(function (t) { return SEARCH_CORRECTIONS[t] || t; }); // fix known typos
    // De-duplicate words (a sanitized scoped query repeats each term once per field,
    // and a duplicate term in an AND query is redundant anyway).
    var seen = {};
    tokens = tokens.filter(function (t) { if (seen[t]) return false; seen[t] = true; return true; });
    if (!tokens.length) return '';
    // A scoped variants.sku:X* only matches from the START of the full SKU, so a
    // partial lookup ("26764", "nx-26764", "cable-02") finds nothing. Shopify's
    // unscoped search does match SKU fragments, but only as its own AND term (it
    // stops matching when OR'd inside a scoped group), so SKU-like words go in plain.
    return tokens
      .map(function (t) {
        if (looksLikeSku(t)) return t;
        return '(' + FIELDS.map(function (f) { return f + ':' + t + '*'; }).join(' OR ') + ')';
      })
      .join(' AND ');
  };

  // 3+ digits in a row, or a hyphen next to digits: "26764", "j-nx-2676", "ao-52".
  // Leaves normal words like "14k" or "6.50" on the scoped path.
  function looksLikeSku(t) {
    return /\d{3,}|-\w*\d|\d\w*-/.test(t);
  }

  // Rewrite one search form: put the scoped query in a hidden "q" field and stop
  // the visible box from submitting its raw value (so the typed text stays visible).
  var applyScopedSearch = function (form) {
    if (!form) return;
    var input = form.querySelector('input[type="search"][name="q"]');
    if (!input) return;
    var raw = input.value || '';
    // If the box already holds a scoped query (results-page pre-fill or a back-button
    // re-submit), strip the scope syntax back to plain words FIRST so typo-correction
    // still runs. (We must remove the field prefixes as whole words here — the
    // per-token cleaner below only strips punctuation, so "(title:turquoise*" would
    // otherwise become the junk token "titleturquoise" and match nothing.)
    if (/\b(?:title|tag|product_type|variants\.sku)\s*:/i.test(raw) || /[*()]/.test(raw)) {
      raw = raw
        .replace(/\b(?:title|tag|product_type|variants\.sku)\s*:/gi, ' ')
        .replace(/[*()]/g, ' ')
        .replace(/\b(?:OR|AND)\b/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }
    var scoped = toScopedQuery(raw);
    if (!scoped) return;
    var hidden = form.querySelector('input[type="hidden"][data-title-q]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.setAttribute('data-title-q', '');
      form.appendChild(hidden);
    }
    hidden.name = 'q';
    hidden.value = scoped;
    input.removeAttribute('name');
  };

  // Exposed so inline scripts can call it directly if ever needed.
  window.applyScopedSearch = applyScopedSearch;

  // (1) Delegated capture handler — covers all current & future data-title-search forms.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target && e.target.closest && e.target.closest('form[data-title-search]');
      if (form) applyScopedSearch(form);
    },
    true
  );

  // (2) Direct capture binding as a guaranteed fallback (esp. the results-page form).
  var bindAll = function () {
    var forms = document.querySelectorAll('form[data-title-search]');
    for (var i = 0; i < forms.length; i++) {
      forms[i].addEventListener('submit', function (e) { applyScopedSearch(e.currentTarget); }, true);
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
})();
